import ConsultantTalentCard from './ConsultantTalentCard';
export default ConsultantTalentCard;